import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateBranchComponent = loadable(
  () => import("../../components/Branch/CreateBranch")
);
const CreateBranch = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["branch"],
    navigateURL: "/branch",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.BRANCH}`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.primary_contact}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create Branch</span>
      </div>
      <CreateBranchComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateBranch;
